/* =============================================================================
   Little's — Pick & Mix → Appstle cart contract
   -----------------------------------------------------------------------------
   Native builder submits ONE parent /cart/add.js line. Do not mount Appstle BAB.
   Property keys are exact — watch the underscore counts:
     _appstle-bb-id (1)   __appstle-bb-name (2)
     _appstle-bb-product-sku (1)   __appstle-bb-variants (2)

   Storefront UI has 3 bundles. Flavoured Instant merges caffeinated + decaf
   children in one picker. Parent line is still an existing Appstle product:
     all-decaf box → decaf parent
     mixed / all-flavoured → flavoured parent variant for that decaf count
     (PNM-MIX-0 … PNM-MIX-5, or title like "3 flavoured + 3 decaf")
   ============================================================================= */

(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
  if (root) {
    root.PickNMix = api;
  }
})(typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var SELLING_PLANS = {
    '2': '710578930043',
    '4': '710578962811',
    '6': '710578995579',
    '8': '710579028347'
  };

  var BUNDLES = {
    flavoured: {
      key: 'flavoured',
      label: 'Flavoured Instant',
      collections: ['flavour-infused-instant', 'decaf-infused-instant'],
      parentVariantId: 56408134910331,
      oneTimePrice: 2550,
      subscribePrice: 2295,
      decafParentVariantId: 54920252457339,
      decafOneTimePrice: 2700,
      decafSubscribePrice: 2430,
      bbId: 'oykqqjas',
      bbName: 'instant',
      sellingPlans: SELLING_PLANS
    },
    classic: {
      key: 'classic',
      label: 'Classic Instant',
      collections: ['classic-instant-coffee'],
      parentVariantId: 54921442328955,
      oneTimePrice: 4200,
      subscribePrice: 3780,
      bbId: 'oykqqjas',
      bbName: 'instant',
      sellingPlans: SELLING_PLANS
    },
    capsules: {
      key: 'capsules',
      label: 'Coffee Capsules',
      collections: ['nespresso-capsules'],
      parentVariantId: 54921419948411,
      oneTimePrice: 2550,
      subscribePrice: 2295,
      bbId: 'oykqqjas',
      bbName: 'instant',
      sellingPlans: SELLING_PLANS
    }
  };

  var BOX_SIZE = 6;
  var SUBSCRIBE_RATE = 0.9;
  var mixByDecafCount = {};

  function mixKeyFromVariant(variant) {
    var sku = String(variant && variant.sku ? variant.sku : '').toUpperCase();
    var skuMatch = sku.match(/PNM-MIX-(\d)/);
    if (skuMatch) return skuMatch[1];

    var title = String((variant && (variant.title || variant.option1)) || '').toLowerCase();
    if (!title || title === 'default title') return '0';
    if (/6\s*decaf/.test(title) && !/flavoured|regular/.test(title)) return '6';
    var decafMatch = title.match(/(\d+)\s*decaf/);
    if (decafMatch) return decafMatch[1];
    if (/6\s*(flavoured|regular|instant)/.test(title)) return '0';
    return null;
  }

  function setMixVariants(list) {
    mixByDecafCount = {};
    (list || []).forEach(function (variant) {
      var key = mixKeyFromVariant(variant);
      var id = Number(variant && variant.id);
      if (key == null || !id) return;
      mixByDecafCount[key] = {
        id: id,
        price: Number(variant.price) || 0
      };
    });
    return mixByDecafCount;
  }

  function decafQty(selections) {
    return collapseSelections(selections).reduce(function (sum, item) {
      return sum + (isDecafSelection(item) ? Number(item.qty) : 0);
    }, 0);
  }

  function isDecafSelection(selection) {
    var family = String(selection && selection.family ? selection.family : '').toLowerCase();
    if (family === 'decaf') return true;
    if (family === 'caffeinated' || family === 'flavoured') return false;
    var sku = String(selection && selection.sku ? selection.sku : '').toUpperCase();
    return sku.indexOf('DECAF') !== -1;
  }

  function collapseSelections(selections) {
    var byVariant = {};
    (selections || []).forEach(function (item) {
      var qty = Number(item && item.qty ? item.qty : 0);
      if (!item || qty < 1 || !item.variantId) return;
      var id = String(item.variantId);
      if (!byVariant[id]) {
        byVariant[id] = {
          variantId: item.variantId,
          sku: item.sku,
          name: item.name,
          variantTitle: item.variantTitle,
          family: item.family,
          qty: 0
        };
      }
      byVariant[id].qty += qty;
    });
    return Object.keys(byVariant).map(function (id) {
      return byVariant[id];
    });
  }

  function resolveParent(bundleKey, selections) {
    var bundle = BUNDLES[bundleKey];
    if (!bundle) throw new Error('Unknown bundle: ' + bundleKey);

    var items = collapseSelections(selections);
    var allDecaf = bundleKey === 'flavoured' && items.length > 0 && items.every(isDecafSelection);

    if (allDecaf) {
      return {
        key: bundleKey,
        label: bundle.label,
        parentVariantId: bundle.decafParentVariantId,
        oneTimePrice: bundle.decafOneTimePrice,
        subscribePrice: bundle.decafSubscribePrice,
        bbId: bundle.bbId,
        bbName: bundle.bbName,
        sellingPlans: bundle.sellingPlans,
        pricingFamily: 'decaf'
      };
    }

    if (bundleKey === 'flavoured') {
      var mix = mixByDecafCount[String(decafQty(items))];
      if (mix && mix.id) {
        return {
          key: bundleKey,
          label: bundle.label,
          parentVariantId: mix.id,
          oneTimePrice: mix.price || bundle.oneTimePrice,
          subscribePrice: Math.round((mix.price || bundle.oneTimePrice) * SUBSCRIBE_RATE),
          bbId: bundle.bbId,
          bbName: bundle.bbName,
          sellingPlans: bundle.sellingPlans,
          pricingFamily: 'caffeinated'
        };
      }
    }

    return {
      key: bundleKey,
      label: bundle.label,
      parentVariantId: bundle.parentVariantId,
      oneTimePrice: bundle.oneTimePrice,
      subscribePrice: bundle.subscribePrice,
      bbId: bundle.bbId,
      bbName: bundle.bbName,
      sellingPlans: bundle.sellingPlans,
      pricingFamily: bundleKey === 'flavoured' ? 'caffeinated' : bundleKey
    };
  }

  function buildPayload(bundleKey, selections, mode, frequency) {
    var parent = resolveParent(bundleKey, selections);
    var items = collapseSelections(selections);
    var totalQty = items.reduce(function (sum, item) {
      return sum + item.qty;
    }, 0);

    if (totalQty !== BOX_SIZE) {
      throw new Error('Box must contain exactly ' + BOX_SIZE + ' items (got ' + totalQty + ')');
    }

    var productsStr = items
      .map(function (item) {
        return item.qty + 'x ' + item.name + ' - ' + item.variantTitle;
      })
      .join(', ');

    var skuStr = items
      .map(function (item) {
        return item.sku;
      })
      .join(',');

    var variantsStr = items
      .map(function (item) {
        return item.variantId + ':' + item.qty;
      })
      .join(',');

    var line = {
      id: parent.parentVariantId,
      quantity: 1,
      properties: {
        products: productsStr,
        '_appstle-bb-id': parent.bbId,
        '__appstle-bb-name': parent.bbName,
        '_appstle-bb-product-sku': skuStr,
        '__appstle-bb-variants': variantsStr
      }
    };

    if (mode === 'subscribe') {
      var planId = parent.sellingPlans[String(frequency)];
      if (!planId) throw new Error('Unknown frequency: ' + frequency);
      line.selling_plan = Number(planId);
    }

    return { items: [line] };
  }

  function addToCart(bundleKey, selections, mode, frequency, options) {
    var body = buildPayload(bundleKey, selections, mode, frequency);
    options = options || {};
    if (options.sections) {
      body.sections = options.sections;
      body.sections_url = options.sections_url || (typeof window !== 'undefined' ? window.location.pathname : '/');
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          throw new Error((data && (data.description || data.message)) || 'Add to cart failed (' + res.status + ')');
        }
        return data;
      });
    });
  }

  return {
    BUNDLES: BUNDLES,
    BOX_SIZE: BOX_SIZE,
    SELLING_PLANS: SELLING_PLANS,
    collapseSelections: collapseSelections,
    mixKeyFromVariant: mixKeyFromVariant,
    setMixVariants: setMixVariants,
    decafQty: decafQty,
    resolveParent: resolveParent,
    buildPayload: buildPayload,
    addToCart: addToCart
  };
});
